import axios from "axios";
import { applyTheme, saveTheme } from "@/services/themeService.js";

export default {
  async Login({ commit }, Form) {
    try {
      const response = await axios.post("/login", Form);
      localStorage.setItem("token", response.data.data.token);
      localStorage.setItem("is_master", response.data.data.is_master ? "1" : "0");
      commit("setUser", { user: response });

      // Apply theme saved on server if available, else keep local
      const serverTheme = response.data.data.theme;
      if (serverTheme) {
        commit("setTheme", serverTheme);
        applyTheme(serverTheme);
      }

      return response;
    } catch (error) {
      return error.response;
    }
  },

  logout({ commit }) {
    commit("logout");
  },

  setTheme({ commit, state }, theme) {
    commit("setTheme", theme);
    applyTheme(theme);

    // Sync to server (non-blocking)
    if (state.token) {
      axios.post("/user/update-theme", { theme }).catch(() => {});
    }
  },
};
